import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { RealmItem } from 'app/bff-api';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { OrgNavigationService } from 'app/services/org-nav.service';
import { StorageService } from 'app/services/storage/storage.service';
import { AuthConfigService } from 'app/sso.config';

@Component({
    selector: 'sub-sign-in',
    imports: [],
    templateUrl: './sub-sign-in.component.html',
    styleUrl: './sub-sign-in.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubSignInComponent {
    companyLogo?: string;

    private _checkedIn: boolean = false;

    public get checkedIn() {
        return this._checkedIn;
    }

    private set checkedIn(checkedIn: boolean) {
        this._checkedIn = checkedIn;
        // this.constructForm();
    }

    constructor(
        private _authService: AuthService,
        private oauthService: OAuthService,
        private orgNav: OrgNavigationService,
        private _userService: UserService,
        private storageService: StorageService,
        private authConfigService: AuthConfigService
    ) {
        localStorage.removeItem('teams');
        this.selectRealm({ value: 'm0061' });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    private configureOAuth(clientId: string): void {
        let config = this.authConfigService.authConfig;
        const idToken = this.oauthService.getIdToken();
        localStorage.setItem('id_token', idToken);

        config.logoutUrl = `${config.authBase}/realms/${clientId}/protocol/openid-connect/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${encodeURIComponent(config.postLogoutRedirectUri)}`;

        if (!config.issuer.endsWith(clientId)) {
            config.issuer = config.authBase + '/realms/' + clientId;
        }

        this.oauthService.configure(config);
        this.oauthService.setupAutomaticSilentRefresh();
    }
    /**
     * On init
     */
    ngOnInit(): void {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    async selectRealm(realm: RealmItem): Promise<void> {
        this.checkedIn = true;
        this.companyLogo = realm.value;
        const clientId = 'subscriptions';
        this.storageService.setClientId(clientId); //localStorage.setItem('clientId', clientId);
        this._userService.id = clientId;

        this.configureOAuth(clientId);
        this.oauthService.loadDiscoveryDocument().then(res => {
            this.oauthService.initCodeFlow();
        });
    }
}
